var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFCA27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59998 26.4C9.59998 25.7373 10.1372 25.2 10.8 25.2H25.2C25.8627 25.2 26.4 25.7373 26.4 26.4C26.4 27.0627 25.8627 27.6 25.2 27.6H10.8C10.1372 27.6 9.59998 27.0627 9.59998 26.4ZM13.5514 17.1515C14.0201 16.6828 14.7799 16.6828 15.2485 17.1515L16.8 18.7029L16.8 9.6C16.8 8.93726 17.3372 8.4 18 8.4C18.6627 8.4 19.2 8.93726 19.2 9.6L19.2 18.7029L20.7514 17.1515C21.2201 16.6828 21.9799 16.6828 22.4485 17.1515C22.9171 17.6201 22.9171 18.3799 22.4485 18.8485L18.8485 22.4485C18.6235 22.6736 18.3182 22.8 18 22.8C17.6817 22.8 17.3765 22.6736 17.1514 22.4485L13.5514 18.8485C13.0828 18.3799 13.0828 17.6201 13.5514 17.1515Z",
    fill: "#4D4D4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/download-btn.09f14d2f8aadc316ff539c744917a9af.svg";
export { ForwardRef as ReactComponent };